import Moment from "@/services/moment";

export const formatUnixTimestamp = (unixTimestamp: number, format: string): string =>
  Moment.unix(unixTimestamp).format(format);

export const timestampRangeToHours = (startTime: number, endTime: number): string =>
  String(Math.round((endTime - startTime) / 3600 * 100) / 100).replace(".", ",");
